module.exports = __webpack_public_path__ + "img/loading.86843212.gif";